import { useState, useRef, useEffect, forwardRef } from 'react';
import './projects.css';
import Mydiary from './projects/Mydiary';
import Cheeus from './projects/Cheeus';
import Smartmirror from './projects/Smartmirror';

const projects = [
  { file:<Cheeus/> ,id: 1, 제목: '🍺 동네 술 친구 사귀기 웹 앱', 기간: '2024.07 ~ 2024.08', 상세내용: '이 앱은 동네에서 술 친구를 찾는 플랫폼입니다.' },
  { file:<Mydiary/> ,id: 2, 제목: '📓 My Diary, 간단한 일기 웹 앱', 기간: '2024.03 ~ 2024.03', 상세내용: '일기를 기록하고, 마음을 나누는 공간입니다.' },
  { file:<Smartmirror/> ,id: 3, 제목: '🪞 안면인식을 사용하여 보안성을 강화한 스마트 미러', 기간: '2022.03 ~ 2022.11', 상세내용: '안면 인식을 통한 보안 기능을 갖춘 스마트 미러입니다.' },
];

const Projects = forwardRef((props, ref) => {
  const [selectedProject, setSelectedProject] = useState(projects[0]);
  const [prevSelectedProject, setPrevSelectedProject] = useState(null);
  const [prevSelectedProject2, setPrevSelectedProject2] = useState(null);
  const [state, setState] = useState(0); // 상태: 0, 1, 2
  const carouselRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const handleProjectClick = (data) => {
    // 선택된 프로젝트가 변경되면 상태를 2로 설정 (애니메이션 필요)
    if (data.id !== selectedProject.id) {
      setState(prevState => (prevState === 2 ? 3 : 2)); // 상태가 2이면 3으로, 3이면 2로 변경
    } else {
      setState(1); // 동일한 프로젝트 클릭 시 다른 상태
    }

    // 상태 변경
    setPrevSelectedProject(selectedProject);
    setPrevSelectedProject2(selectedProject); // 이전 프로젝트를 prevSelectedProject2로 설정
    setSelectedProject(data);
  };

  useEffect(() => {
    console.log("State changed to:", state);
  }, [state]);

  // 드래그 시작
  const handleMouseDown = (e) => {
    // 화면 너비가 1200px 이하일 때 드래그를 비활성화
    if (window.innerWidth <= 1200) return;
  
    isDragging.current = true;
    startX.current = e.pageX - carouselRef.current.offsetLeft; // 마우스 시작 위치
    scrollLeft.current = carouselRef.current.scrollLeft; // 현재 스크롤 위치
    carouselRef.current.style.cursor = 'grabbing'; // 드래그 중 커서 변경
  };
  
  // 드래그 이동 핸들러
  const handleMouseMove = (e) => {
    // 화면 너비가 1200px 이하일 때 드래그를 비활성화
    if (!isDragging.current || window.innerWidth <= 1200) return;
  
    const x = e.pageX - carouselRef.current.offsetLeft; // 마우스 위치
    const walk = (x - startX.current); // 이동 거리 (방향은 그대로)
  
    const maxScroll = carouselRef.current.scrollWidth - carouselRef.current.offsetWidth;
    const newScrollLeft = scrollLeft.current - walk;
  
    // 저항 효과: 최대 스크롤 범위를 벗어났을 때 반대로 밀리는 효과
    if (newScrollLeft < 0) {
      carouselRef.current.style.transform = `translateX(${-(newScrollLeft * 0.2)}px)`; // 좌측으로 밀려나면 왼쪽으로 밀리는 효과
    } else if (newScrollLeft > maxScroll) {
      carouselRef.current.style.transform = `translateX(${-(newScrollLeft - maxScroll) * 0.2}px)`; // 우측으로 밀려나면 오른쪽으로 밀리는 효과
    } else {
      carouselRef.current.style.transform = 'translateX(0)'; // 기본 위치
    }
  
    carouselRef.current.scrollLeft = Math.max(0, Math.min(newScrollLeft, maxScroll)); // scrollLeft 값 제한
  };
  
  // 드래그 끝
  const handleMouseUp = () => {
    // 화면 너비가 1200px 이하일 때 드래그를 비활성화
    if (window.innerWidth <= 1200) return;
  
    isDragging.current = false;
    carouselRef.current.style.cursor = 'grab'; // 드래그 끝나면 커서 복구
    carouselRef.current.style.transform = 'translateX(0)'; // 저항 효과 종료
  };
  
  // 드래그가 끝났을 때
  const handleMouseLeave = () => {
    // 화면 너비가 1200px 이하일 때 드래그를 비활성화
    if (window.innerWidth <= 1200) return;
  
    if (isDragging.current) {
      isDragging.current = false;
      carouselRef.current.style.cursor = 'grab'; // 드래그 중 마우스가 벗어났을 때
      carouselRef.current.style.transform = 'translateX(0)';
    }
  };
  
  // 마우스 이벤트를 document에 등록하여 영역 벗어났을 때도 드래그 유지
  useEffect(() => {
    // document에 이벤트 등록
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mouseleave', handleMouseLeave);
  
    // 컴포넌트 언마운트 시 이벤트 제거
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);
  

  useEffect(() => {
    const observerOptions = {
      rootMargin: "0px",
      threshold: 0.5, // 화면의 50%가 보일 때 트리거
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show"); // 화면에 보일 때 show 클래스를 추가
        }
      });
    }, observerOptions);

    // 각 intro 요소를 관찰
    const elementsToObserve = document.querySelectorAll(".projects-container");
    elementsToObserve.forEach(el => observer.observe(el));
  }, []);

  return (
    <div className="projects" ref={ref}>
        <div className="projects-header">PROJECTS</div>
      <div className="projects-container">

        <div className="projects-contents">
          <div className="left-box"></div>
          <div className="projects-carousel-cover-top">
            <div
              className="projects-carousel-cover"
              ref={carouselRef}
              onMouseDown={handleMouseDown}
            >
              <div className="projects-carousel">
                {projects.map((data) => (
                  <div
                    key={data.id}
                    className={`project-item ${selectedProject?.id === data.id ? 'selected' : ''}`}
                    onClick={() => handleProjectClick(data)}
                  >
                    <div className="title">{data.제목}</div>
                    <div className="period">{data.기간}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="right-box"></div>
        </div>
        
        <div className="projects-contents-detail-container">
          {state === 0 && (
            <div className={`projects-contents-detail ${selectedProject ? 'open' : ''}`}>
              <h3>{selectedProject.제목}</h3>
              <p>{selectedProject.상세내용}</p>
              <div>{selectedProject.file}</div>
            </div>
          )}

          {state === 1 && (
            <div className={`projects-contents-detail-opened`}>
              <h3>{selectedProject.제목}</h3>
              <p>{selectedProject.상세내용}</p>
              <div>{selectedProject.file}</div>
            </div>
          )}

          {(state === 2) && (
            <>
              <div
                className="projects-contents-detail"
                style={{ animation: 'collapse 0.5s ease-out forwards' }}
              >
                <h3>{prevSelectedProject2?.제목}</h3>
                <p>{prevSelectedProject2?.상세내용}</p>
              </div>
              <div
                className="projects-contents-detail"
                style={{ animation: 'expand 0.5s 0.5s ease-out forwards' }}
              >
                <h3>{selectedProject?.제목}</h3>
                <p>{selectedProject?.상세내용}</p>
                <div>{selectedProject.file}</div>
              </div>
            </>
          )}
          {(state === 3) && (
            <>
              <div
                className="projects-contents-detail"
                style={{ animation: 'collapse 0.5s ease-out forwards' }}
              >
                <h3>{prevSelectedProject2?.제목}</h3>
                <p>{prevSelectedProject2?.상세내용}</p>
              </div>
              <div
                className="projects-contents-detail"
                style={{ animation: 'expand 0.5s 0.5s ease-out forwards' }}
              >
                <h3>{selectedProject?.제목}</h3>
                <p>{selectedProject?.상세내용}</p>
                <div>{selectedProject.file}</div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
});

export default Projects;
